import { gql } from '@apollo/client'
import {
  AGGREGATE_DETAILS,
  AGGREGATE_DETAILS_AVERAGE,
  AGGREGATE_DETAILS_NO_DATA_LIMIT,
  AGGREGATE_DETAILS_NO_SERIES_LIMIT,
  AGGREGATE_DETAILS_NO_SERIES_LIMIT_NO_SUMMARY,
  AGGREGATE_DETAILS_NO_SUMMARY,
  AGGREGATE_DETAILS_WITH_SUMMARY,
  AGGREGATE_RATING_DETAILS,
  AGGREGATE_RATING_TREND_DETAILS,
  SERIES_SUMMARY,
  SUMMARY_SERIES_DETAILS,
} from './fragments'

export const GET_ALL_FILTERS = gql`
  query filters($schema: String, $context: [CellInput]!) {
    filters(schema: $schema, context: $context)
  }
`

export const SINGLE_SUMMARY_QUERY = gql`
  ${SERIES_SUMMARY}
  query OverViewSummary(
    $primaryVar: SingleVariable!
    $filters: [Filter!]
    $context: [CellInput]!
    $localFilters: [Filter!] = []
  ) {
    cross: crossSingle(
      primary: $primaryVar
      secondary: $primaryVar
      filters: $filters
      context: $context
      localFilters: $localFilters
    ) {
      totalCount
      totalCountUnweighted
      series {
        ...SeriesSummaryFragment
      }
    }
  }
`

export const CROSS_SINGLE_QUERY = gql`
  ${AGGREGATE_DETAILS}

  query CrossSingleQuery(
    $primaryVar: SingleVariable!
    $secondaryVar: SingleVariable!
    $tertiaryVar: SingleVariable
    $filters: [Filter!]
    $localFilters: [Filter!] = []
    $limitSeries: Int
    $limitDataPoints: Int
    $chartType: String
    $context: [CellInput]!
    $schema: String
    $removeDataPoints: [Int]
    $showDataPoints: [Int]
    $pageNumber: Int
    $itemsPerPage: Int
    $totalItems: Int
    $reviewAverage: Boolean
  ) {
    cross: crossSingle(
      primary: $primaryVar
      secondary: $secondaryVar
      filters: $filters
      context: $context
      localFilters: $localFilters
      schema: $schema
      removeDataPoints: $removeDataPoints
      showDataPoints: $showDataPoints
      pageNumber: $pageNumber
      itemsPerPage: $itemsPerPage
      totalItems: $totalItems
      tertiary: $tertiaryVar
      reviewAverage: $reviewAverage
    ) {
      ...AggregateDetailsFragment
    }
  }
`
export const CROSS_SINGLE_EXPORT_QUERY = gql`
  ${AGGREGATE_DETAILS_NO_DATA_LIMIT}

  query CrossSingleQuery(
    $primaryVar: SingleVariable!
    $secondaryVar: SingleVariable!
    $tertiaryVar: SingleVariable
    $filters: [Filter!]
    $localFilters: [Filter!] = []
    $context: [CellInput]!
    $schema: String
    $removeDataPoints: [Int]
    $showDataPoints: [Int]
    $totalItems: Int
    $reviewAverage: Boolean
  ) {
    cross: crossSingle(
      primary: $primaryVar
      secondary: $secondaryVar
      filters: $filters
      context: $context
      localFilters: $localFilters
      schema: $schema
      removeDataPoints: $removeDataPoints
      showDataPoints: $showDataPoints
      totalItems: $totalItems
      tertiary: $tertiaryVar
      reviewAverage: $reviewAverage
    ) {
      ...AggregateDetailsNoLimitFragment
    }
  }
`

export const CROSS_SINGLE_EXPORT_HEATMAP_QUERY = gql`
  ${AGGREGATE_DETAILS_NO_SERIES_LIMIT}

  query CrossSingleQuery(
    $primaryVar: SingleVariable!
    $secondaryVar: SingleVariable!
    $tertiaryVar: SingleVariable
    $filters: [Filter!]
    $localFilters: [Filter!] = []
    $context: [CellInput]!
    $schema: String
    $removeDataPoints: [Int]
    $showDataPoints: [Int]
    $totalItems: Int
    $reviewAverage: Boolean
    $limitDataPoints: Int
  ) {
    cross: crossSingle(
      primary: $primaryVar
      secondary: $secondaryVar
      filters: $filters
      context: $context
      localFilters: $localFilters
      schema: $schema
      removeDataPoints: $removeDataPoints
      showDataPoints: $showDataPoints
      totalItems: $totalItems
      tertiary: $tertiaryVar
      reviewAverage: $reviewAverage
    ) {
      ...AggregateDetailsNoSeriesLimitFragment
    }
  }
`

export const CROSS_SINGLE_FACTOR_QUERY = gql`
  ${AGGREGATE_DETAILS_AVERAGE}

  query CrossSingleFactorQuery(
    $primaryVar: SingleVariable!
    $secondaryVar: SingleVariable!
    $filters: [Filter!]
    $localFilters: [Filter!]
    $limitSeries: Int
    $limitDataPoints: Int
    $context: [CellInput]!
    $pageNumber: Int
    $itemsPerPage: Int
    $totalItems: Int
  ) {
    cross: crossSingleFactor(
      primary: $primaryVar
      secondary: $secondaryVar
      filters: $filters
      context: $context
      localFilters: $localFilters
      pageNumber: $pageNumber
      itemsPerPage: $itemsPerPage
      totalItems: $totalItems
    ) {
      ...AggregateDetailsAverageFragment
    }
  }
`

export const MULTI_CROSS_SINGLE_FACTOR_QUERY = gql`
  ${AGGREGATE_DETAILS_AVERAGE}

  query MultiCrossSingleFactorQuery(
    $primaryVar: SingleVariable!
    $secondaryVar: SingleVariable!
    $filters: [Filter!]
    $firstLocalFilters: [Filter!]
    $secondLocalFilters: [Filter!]
    $limitSeries: Int
    $limitDataPoints: Int
    $context: [CellInput]!
    $pageNumber: Int
    $itemsPerPage: Int
    $totalItems: Int
  ) {
    cross: crossSingleFactor(
      primary: $primaryVar
      secondary: $secondaryVar
      filters: $filters
      context: $context
      localFilters: $firstLocalFilters
      pageNumber: $pageNumber
      itemsPerPage: $itemsPerPage
      totalItems: $totalItems
    ) {
      ...AggregateDetailsAverageFragment
    }
    cross2: crossSingleFactor(
      primary: $primaryVar
      secondary: $secondaryVar
      filters: $filters
      context: $context
      localFilters: $secondLocalFilters
      pageNumber: $pageNumber
      itemsPerPage: $itemsPerPage
      totalItems: $totalItems
    ) {
      ...AggregateDetailsAverageFragment
    }
  }
`
export const CROSS_SINGLE_AVERAGE_QUERY = gql`
  ${AGGREGATE_RATING_DETAILS}

  query CrossSingleAverageQuery(
    $primaryVar: SingleVariable!
    $secondaryVar: SingleVariable!
    $filters: [Filter!]
    $localFilters: [Filter!] = []
    $limitSeries: Int
    $limitDataPoints: Int
    $context: [CellInput]!
    $schema: String
    $removeDataPoints: [Int]
    $showDataPoints: [Int]
    $pageNumber: Int
    $itemsPerPage: Int
    $totalItems: Int
  ) {
    cross: crossSingleAverage(
      primary: $primaryVar
      secondary: $secondaryVar
      filters: $filters
      context: $context
      localFilters: $localFilters
      schema: $schema
      removeDataPoints: $removeDataPoints
      showDataPoints: $showDataPoints
      pageNumber: $pageNumber
      itemsPerPage: $itemsPerPage
      totalItems: $totalItems
    ) {
      ...AggregateRatingDetailsFragment
    }
  }
`

export const CROSS_SINGLE_AND_MULTI_QUERY = gql`
  ${AGGREGATE_DETAILS}

  query CrossSingleAndMultiQuery(
    $primaryVar: SingleVariable!
    $secondaryVar: MultiVariable!
    $filters: [Filter!]
    $localFilters: [Filter!]
    $limitSeries: Int
    $limitDataPoints: Int
    $context: [CellInput]!
    $chartType: String
    $removeDataPoints: [Int]
    $showDataPoints: [Int]
    $pageNumber: Int
    $itemsPerPage: Int
    $totalItems: Int
    $paginationOn: String
  ) {
    cross: crossSingleAndMulti(
      primary: $primaryVar
      secondary: $secondaryVar
      filters: $filters
      context: $context
      localFilters: $localFilters
      removeDataPoints: $removeDataPoints
      showDataPoints: $showDataPoints
      pageNumber: $pageNumber
      itemsPerPage: $itemsPerPage
      totalItems: $totalItems
      paginationOn: $paginationOn
    ) {
      ...AggregateDetailsFragment
    }
  }
`
export const DOUBLE_CROSS_SINGLE_AND_MULTI_QUERY = gql`
  ${AGGREGATE_DETAILS}

  query DoubleCrossSingleAndMultiQuery(
    $primaryVar: SingleVariable!
    $secondaryVar: MultiVariable!
    $secondPrimaryVar: SingleVariable!
    $tertiaryVar: SingleVariable
    $filters: [Filter!]
    $localFilters: [Filter!]
    $limitSeries: Int
    $limitDataPoints: Int
    $context: [CellInput]!
    $schema: String
    $chartType: String
    $removeDataPoints: [Int]
    $showDataPoints: [Int]
    $pageNumber: Int
    $itemsPerPage: Int
    $totalItems: Int
    $paginationOn: String
    $reviewAverage: Boolean
  ) {
    cross: crossSingleAndMulti(
      primary: $primaryVar
      secondary: $secondaryVar
      filters: $filters
      context: $context
      localFilters: $localFilters
      removeDataPoints: $removeDataPoints
      showDataPoints: $showDataPoints
      pageNumber: $pageNumber
      itemsPerPage: $itemsPerPage
      totalItems: $totalItems
      paginationOn: $paginationOn
    ) {
      ...AggregateDetailsFragment
    }
    cross2: crossSingle(
      primary: $primaryVar
      secondary: $secondPrimaryVar
      filters: $filters
      context: $context
      localFilters: $localFilters
      schema: $schema
      removeDataPoints: $removeDataPoints
      showDataPoints: $showDataPoints
      pageNumber: $pageNumber
      itemsPerPage: $itemsPerPage
      totalItems: $totalItems
      tertiary: $tertiaryVar
      reviewAverage: $reviewAverage
    ) {
      ...AggregateDetailsFragment
    }
  }
`
export const CROSS_SINGLE_AND_VERBATIMS = gql`
  ${AGGREGATE_DETAILS_WITH_SUMMARY}

  query CrossSingleAndVerbatimsQuery(
    $primaryVar: SingleVariable!
    $secondaryVar: MultiVariable!
    $filters: [Filter!]
    $localFilters: [Filter!]
    $context: [CellInput]!
    $showDataPoints: [Int]
    $pageNumber: Int
    $itemsPerPage: Int
    $totalItems: Int
    $paginationOn: String
    $tags: [String]
  ) {
    cross: crossSingleVerbatims(
      primary: $primaryVar
      secondary: $secondaryVar
      filters: $filters
      context: $context
      localFilters: $localFilters
      showDataPoints: $showDataPoints
      pageNumber: $pageNumber
      itemsPerPage: $itemsPerPage
      totalItems: $totalItems
      paginationOn: $paginationOn
      tags: $tags
    ) {
      ...AggregateDetailsWithSummaryFragment
    }
  }
`

export const CROSS_SINGLE_VERBATIMS_SUMMARY = gql`
  query CrossSingleVerbatimsSummary(
    $primaryVar: SingleVariable!
    $secondaryVar: MultiVariable!
    $filters: [Filter!]
    $localFilters: [Filter!]
    $context: [CellInput]!
    $showDataPoints: [Int]
    $pageNumber: Int
    $itemsPerPage: Int
    $totalItems: Int
    $paginationOn: String
    $tags: [String]
  ) {
    cross: crossSingleVerbatimsSummaries(
      primary: $primaryVar
      secondary: $secondaryVar
      filters: $filters
      context: $context
      localFilters: $localFilters
      showDataPoints: $showDataPoints
      pageNumber: $pageNumber
      itemsPerPage: $itemsPerPage
      totalItems: $totalItems
      paginationOn: $paginationOn
      tags: $tags
    )
  }
`

export const NARRATIVES_SUMMARY = gql`
  query NarrativesSummary($filters: [Filter!], $context: [CellInput]!, $narratives: String!) {
    cross: narrativesSummary(filters: $filters, context: $context, narratives: $narratives)
  }
`

export const CROSS_MULTI_TEXT = gql`
  ${AGGREGATE_DETAILS_NO_DATA_LIMIT}

  query CrossMultiTextQuery(
    $primaryVar: MultiVariable!
    $secondaryVar: MultiVariable!
    $filters: [Filter!]
    $localFilters: [Filter!]
    $context: [CellInput]!
    $showDataPoints: [Int]
    $pageNumber: Int
    $itemsPerPage: Int
    $totalItems: Int
    $paginationOn: String
  ) {
    cross: crossMultiText(
      primary: $primaryVar
      secondary: $secondaryVar
      filters: $filters
      context: $context
      localFilters: $localFilters
      showDataPoints: $showDataPoints
      pageNumber: $pageNumber
      itemsPerPage: $itemsPerPage
      totalItems: $totalItems
      paginationOn: $paginationOn
    ) {
      ...AggregateDetailsNoLimitFragment
    }
  }
`
export const CROSS_SINGLE_AND_MULTI_WITH_PARIMARY_BASE_QUERY = gql`
  ${AGGREGATE_DETAILS}

  query CrossSingleAndMultiWithPrimaryBaseQuery(
    $primaryVar: SingleVariable!
    $secondaryVar: MultiVariable!
    $filters: [Filter!]
    $localFilters: [Filter!]
    $limitSeries: Int
    $limitDataPoints: Int
    $context: [CellInput]!
    $chartType: String
    $removeDataPoints: [Int]
    $showDataPoints: [Int]
    $pageNumber: Int
    $itemsPerPage: Int
    $totalItems: Int
    $paginationOn: String
  ) {
    cross: crossSingleAndMultiWithPrimaryBase(
      primary: $primaryVar
      secondary: $secondaryVar
      filters: $filters
      context: $context
      localFilters: $localFilters
      removeDataPoints: $removeDataPoints
      showDataPoints: $showDataPoints
      pageNumber: $pageNumber
      itemsPerPage: $itemsPerPage
      totalItems: $totalItems
      paginationOn: $paginationOn
    ) {
      ...AggregateDetailsFragment
    }
  }
`

export const CROSS_SINGLE_AND_MULTI_SUMMARY_QUERY = gql`
  ${SUMMARY_SERIES_DETAILS}

  query CrossSingleAndMultiQuery(
    $primaryVar: SingleVariable!
    $secondaryVar: MultiVariable!
    $filters: [Filter!]
    $localFilters: [Filter!]
    $limitDataPoints: Int
    $context: [CellInput]!
  ) {
    cross: crossSingleAndMulti(
      primary: $primaryVar
      secondary: $secondaryVar
      filters: $filters
      context: $context
      localFilters: $localFilters
    ) {
      ...SummarySeriesDetailsFragment
    }
  }
`

export const CROSS_TIME_AND_SINGLE_QUERY = gql`
  ${AGGREGATE_DETAILS}
  query CrossTimeAndSingleQuery(
    $secondaryVar: SingleVariable!
    $tertiaryVar: SingleVariable!
    $filters: [Filter!]
    $localFilters: [Filter!]
    $limitSeries: Int
    $limitDataPoints: Int
    $context: [CellInput]!
    $chartType: String
    $pageNumber: Int
    $itemsPerPage: Int
    $totalItems: Int
    $schema: String
  ) {
    cross: crossTimeAndSingle(
      secondary: $secondaryVar
      tertiary: $tertiaryVar
      filters: $filters
      context: $context
      localFilters: $localFilters
      pageNumber: $pageNumber
      itemsPerPage: $itemsPerPage
      totalItems: $totalItems
      schema: $schema
    ) {
      ...AggregateDetailsFragment
    }
  }
`
export const CROSS_SINGLE_AVERAGE_TREND_QUERY = gql`
  ${AGGREGATE_RATING_TREND_DETAILS}
  query CrossSingleAverageTrend(
    $primaryVar: SingleVariable!
    $secondaryVar: SingleVariable!
    $tertiaryVar: SingleVariable!
    $filters: [Filter!]
    $localFilters: [Filter!]
    $limitSeries: Int
    $limitDataPoints: Int
    $context: [CellInput]!
    $pageNumber: Int
    $itemsPerPage: Int
    $totalItems: Int
    $schema: String
  ) {
    cross: crossSingleAverageTrend(
      primary: $primaryVar
      secondary: $secondaryVar
      tertiary: $tertiaryVar
      filters: $filters
      context: $context
      localFilters: $localFilters
      pageNumber: $pageNumber
      itemsPerPage: $itemsPerPage
      totalItems: $totalItems
      schema: $schema
    ) {
      ...AggregateRatingTrendDetailsFragment
    }
  }
`
export const SOLITARY_MULTI_QUERY = gql`
  ${AGGREGATE_DETAILS_NO_SERIES_LIMIT}
  query SolitaryMulti(
    $primaryVar: MultiVariable!
    $filters: [Filter!]
    $localFilters: [Filter!]
    $limitDataPoints: Int
    $context: [CellInput]!
    $pageNumber: Int
    $itemsPerPage: Int
    $totalItems: Int
    $showDataPoints: [Int]
    $removeDataPoints: [Int]
  ) {
    cross: solitaryMulti(
      primary: $primaryVar
      filters: $filters
      context: $context
      localFilters: $localFilters
      pageNumber: $pageNumber
      itemsPerPage: $itemsPerPage
      totalItems: $totalItems
      showDataPoints: $showDataPoints
      removeDataPoints: $removeDataPoints
    ) {
      ...AggregateDetailsNoSeriesLimitFragment
    }
  }
`

export const MULTI_CROSS_SINGLE_AVERAGE_PRICE_REVENUE_QUERY = gql`
  ${AGGREGATE_DETAILS_AVERAGE}
  query MultiCrossSingleAverageSeries(
    $primaryVar: SingleVariable!
    $secondaryVar: SingleVariable!
    $filters: [Filter!]
    $firstLocalFilters: [Filter!]
    $secondLocalFilters: [Filter!]
    $limitSeries: Int
    $limitDataPoints: Int
    $context: [CellInput]!
  ) {
    cross: crossSingleNumericAvg(
      primary: $primaryVar
      secondary: $secondaryVar
      filters: $filters
      localFilters: $firstLocalFilters
      context: $context
    ) {
      ...AggregateDetailsAverageFragment
    }
    cross2: crossSingleNumericAvg(
      primary: $primaryVar
      secondary: $secondaryVar
      filters: $filters
      localFilters: $secondLocalFilters
      context: $context
    ) {
      ...AggregateDetailsAverageFragment
    }
  }
`

export const CROSS_SINGLE_AVERAGE_PRICE_REVENUE_QUERY = gql`
  ${AGGREGATE_DETAILS_AVERAGE}
  query crossSingleNumericAvgQuery(
    $primaryVar: SingleVariable!
    $secondaryVar: SingleVariable!
    $filters: [Filter!]
    $localFilters: [Filter!]
    $limitSeries: Int
    $limitDataPoints: Int
    $context: [CellInput]!
    $pageNumber: Int
    $itemsPerPage: Int
    $totalItems: Int
  ) {
    cross: crossSingleNumericAvg(
      primary: $primaryVar
      secondary: $secondaryVar
      filters: $filters
      localFilters: $localFilters
      context: $context
      pageNumber: $pageNumber
      itemsPerPage: $itemsPerPage
      totalItems: $totalItems
    ) {
      ...AggregateDetailsAverageFragment
    }
  }
`

export const SOLITARY_SINGLE_QUERY = gql`
  ${AGGREGATE_DETAILS_NO_SERIES_LIMIT}
  query SolitarySingle(
    $primaryVar: SingleVariable!
    $filters: [Filter!]
    $localFilters: [Filter!]
    $limitDataPoints: Int
    $context: [CellInput]!
    $schema: String
    $pageNumber: Int
    $itemsPerPage: Int
    $totalItems: Int
    $removeDataPoints: [Int]
  ) {
    cross: solitarySingle(
      primary: $primaryVar
      filters: $filters
      context: $context
      localFilters: $localFilters
      schema: $schema
      pageNumber: $pageNumber
      itemsPerPage: $itemsPerPage
      totalItems: $totalItems
      removeDataPoints: $removeDataPoints
    ) {
      ...AggregateDetailsNoSeriesLimitFragment
    }
  }
`

export const SOLITARY_SINGLE_SEGMENTATION_QUERY = gql`
  ${AGGREGATE_DETAILS_NO_SERIES_LIMIT}
  query SolitarySingleSegmentation(
    $primaryVar: SingleVariable!
    $filters: [Filter!]
    $localFilters: [Filter!]
    $limitDataPoints: Int
    $context: [CellInput]!
    $schema: String
  ) {
    cross: solitarySingleSegmentation(
      primary: $primaryVar
      filters: $filters
      context: $context
      localFilters: $localFilters
      schema: $schema
    ) {
      ...AggregateDetailsNoSeriesLimitFragment
    }
  }
`

export const GET_FILTER_VALUES = gql`
  query FilterValues(
    $variableId: Int!
    $filters: [Filter!]
    $context: [CellInput]!
    $schema: String
  ) {
    filterValues: filterValues(
      variableId: $variableId
      filters: $filters
      context: $context
      schema: $schema
    ) {
      answer_id
      answer_code
      label
      category_name
    }
  }
`

export const GET_USER_SUBSCRIPTION = gql`
  query {
    context {
      country
      itemGroup
      waves
      subGroup
    }
  }
`

export const UPSELL_ACCESS_QUERY = gql`
  query upsellAccess {
    upsellAccess {
      package_code
    }
  }
`

export const CROSS_SINGLE_FACTOR_AVG_TRENDED_QUERY = gql`
  ${AGGREGATE_DETAILS_AVERAGE}

  query crossSingleFactorAvgTrendedQuery(
    $primaryVar: SingleVariable!
    $secondaryVar: SingleVariable!
    $tertiaryVar: SingleVariable!
    $filters: [Filter!]
    $localFilters: [Filter!]
    $limitSeries: Int
    $limitDataPoints: Int
    $context: [CellInput]!
    $pageNumber: Int
    $itemsPerPage: Int
    $totalItems: Int
  ) {
    cross: crossSingleFactorAvgTrended(
      primary: $primaryVar
      secondary: $secondaryVar
      tertiary: $tertiaryVar
      filters: $filters
      context: $context
      localFilters: $localFilters
      pageNumber: $pageNumber
      itemsPerPage: $itemsPerPage
      totalItems: $totalItems
    ) {
      ...AggregateDetailsAverageFragment
    }
  }
`
export const MULTI_CROSS_SINGLE_FACTOR_AVG_TRENDED_QUERY = gql`
  ${AGGREGATE_DETAILS_AVERAGE}

  query MultiCrossSingleFactorAvgTrendedQuery(
    $primaryVar: SingleVariable!
    $secondaryVar: SingleVariable!
    $tertiaryVar: SingleVariable!
    $filters: [Filter!]
    $firstLocalFilters: [Filter!]
    $secondLocalFilters: [Filter!]
    $limitSeries: Int
    $limitDataPoints: Int
    $context: [CellInput]!
    $pageNumber: Int
    $itemsPerPage: Int
    $totalItems: Int
  ) {
    cross: crossSingleFactorAvgTrended(
      primary: $primaryVar
      secondary: $secondaryVar
      tertiary: $tertiaryVar
      filters: $filters
      context: $context
      localFilters: $firstLocalFilters
      pageNumber: $pageNumber
      itemsPerPage: $itemsPerPage
      totalItems: $totalItems
    ) {
      ...AggregateDetailsAverageFragment
    }
    cross2: crossSingleFactorAvgTrended(
      primary: $primaryVar
      secondary: $secondaryVar
      tertiary: $tertiaryVar
      filters: $filters
      context: $context
      localFilters: $secondLocalFilters
      pageNumber: $pageNumber
      itemsPerPage: $itemsPerPage
      totalItems: $totalItems
    ) {
      ...AggregateDetailsAverageFragment
    }
  }
`
export const CROSS_TIME_SINGLE_NUMERIC_AVERAGE_QUERY = gql`
  ${AGGREGATE_DETAILS_AVERAGE}

  query crossTimeSingleNumericAverageQuery(
    $primaryVar: SingleVariable!
    $secondaryVar: SingleVariable!
    $tertiaryVar: SingleVariable!
    $filters: [Filter!]
    $limitSeries: Int
    $limitDataPoints: Int
    $context: [CellInput]!
    $localFilters: [Filter!]
    $pageNumber: Int
    $itemsPerPage: Int
    $totalItems: Int
  ) {
    cross: crossTimeSingleNumericAverage(
      primary: $primaryVar
      secondary: $secondaryVar
      tertiary: $tertiaryVar
      filters: $filters
      context: $context
      localFilters: $localFilters
      pageNumber: $pageNumber
      itemsPerPage: $itemsPerPage
      totalItems: $totalItems
    ) {
      ...AggregateDetailsAverageFragment
    }
  }
`

export const COMBINED_FUNNEL_QUERY = gql`
  ${AGGREGATE_DETAILS}
  ${AGGREGATE_DETAILS_NO_DATA_LIMIT}
  query CombinedFunnel(
    $firstPrimaryVar: MultiVariable!
    $secondPrimaryVar: MultiVariable!
    $fourthPrimaryVar: SingleVariable!
    $fourthSecondaryVar: SingleVariable!
    $filters: [Filter!]
    $localFilters: [Filter!]
    $limitSeries: Int
    $limitDataPoints: Int
    $context: [CellInput]!
    $chartType: String
    $pageNumber: Int
    $itemsPerPage: Int
    $totalItems: Int
  ) {
    cross: solitaryMulti(
      primary: $firstPrimaryVar
      filters: $filters
      localFilters: $localFilters
      context: $context
      pageNumber: $pageNumber
      itemsPerPage: $itemsPerPage
      totalItems: $totalItems
    ) {
      ...AggregateDetailsFragment
    }
    cross2: solitaryMulti(
      primary: $secondPrimaryVar
      filters: $filters
      localFilters: $localFilters
      context: $context
      pageNumber: $pageNumber
      itemsPerPage: $itemsPerPage
      totalItems: $totalItems
    ) {
      ...AggregateDetailsNoLimitFragment
    }
    cross3: crossSingle(
      primary: $fourthPrimaryVar
      secondary: $fourthSecondaryVar
      filters: $filters
      localFilters: $localFilters
      context: $context
      chartType: $chartType
    ) {
      ...AggregateDetailsNoLimitFragment
    }
  }
`
export const COMBINED_PILL_QUERY = gql`
  ${AGGREGATE_DETAILS}
  ${AGGREGATE_DETAILS_NO_DATA_LIMIT}
  query CombinedFunnel(
    $firstPrimaryVar: SingleVariable!
    $fourthPrimaryVar: MultiVariable!
    $fourthSecondaryVar: MultiVariable!
    $filters: [Filter!]
    $localFilters: [Filter!]
    $limitSeries: Int
    $limitDataPoints: Int
    $context: [CellInput]!
    $chartType: String
    $pageNumber: Int
    $itemsPerPage: Int
    $totalItems: Int
  ) {
    cross: crossSingleAndMulti(
      primary: $firstPrimaryVar
      secondary: $fourthPrimaryVar
      filters: $filters
      context: $context
      localFilters: $localFilters
      pageNumber: $pageNumber
      itemsPerPage: $itemsPerPage
      totalItems: $totalItems
    ) {
      ...AggregateDetailsFragment
    }
    cross2: crossSingleAndMulti(
      primary: $firstPrimaryVar
      secondary: $fourthSecondaryVar
      filters: $filters
      context: $context
      localFilters: $localFilters
      itemsPerPage: $itemsPerPage
      totalItems: $totalItems
    ) {
      ...AggregateDetailsNoLimitFragment
    }
  }
`

export const COMBINED_TABLE_OVERVIEW_QUERY = gql`
  ${AGGREGATE_DETAILS_NO_SERIES_LIMIT}
  ${AGGREGATE_DETAILS_AVERAGE}
  query SolitarySingleSegmentation(
    $primaryVar: SingleVariable!
    $secondaryVar: SingleVariable!
    $thirdVar: SingleVariable!
    $limitSeries: Int
    $filters: [Filter!]
    $firstLocalFilters: [Filter!]
    $limitDataPoints: Int
    $secondLocalFilters: [Filter]
    $thirdLocalFilters: [Filter]
    $fourthLocalFilters: [Filter]
    $fifthLocalFilters: [Filter]
    $sixthLocalFilters: [Filter]
    $seventhLocalFilters: [Filter]
    $eighthLocalFilters: [Filter]
    $ninthLocalFilters: [Filter]
    $context: [CellInput]!
    $schema: String
  ) {
    cross: solitarySingleSegmentation(
      primary: $primaryVar
      filters: $filters
      context: $context
      schema: $schema
    ) {
      ...AggregateDetailsNoSeriesLimitFragment
    }
    cross2: solitarySingleSegmentation(
      primary: $primaryVar
      filters: $filters
      context: $context
      localFilters: $firstLocalFilters
      schema: $schema
    ) {
      ...AggregateDetailsNoSeriesLimitFragment
    }
    cross3: solitarySingleSegmentation(
      primary: $primaryVar
      filters: $filters
      context: $context
      localFilters: $secondLocalFilters
      schema: $schema
    ) {
      ...AggregateDetailsNoSeriesLimitFragment
    }
    cross4: solitarySingleSegmentation(
      primary: $primaryVar
      filters: $filters
      context: $context
      localFilters: $thirdLocalFilters
      schema: $schema
    ) {
      ...AggregateDetailsNoSeriesLimitFragment
    }
    cross5: solitarySingleSegmentation(
      primary: $primaryVar
      filters: $filters
      context: $context
      localFilters: $fourthLocalFilters
      schema: $schema
    ) {
      ...AggregateDetailsNoSeriesLimitFragment
    }
    cross6: crossSingleNumericAvg(
      primary: $primaryVar
      filters: $filters
      context: $context
      secondary: $secondaryVar
    ) {
      ...AggregateDetailsAverageFragment
    }
    cross7: crossSingleNumericAvg(
      primary: $primaryVar
      filters: $filters
      context: $context
      secondary: $thirdVar
    ) {
      ...AggregateDetailsAverageFragment
    }
    cross8: solitarySingleSegmentation(
      primary: $primaryVar
      filters: $filters
      context: $context
      localFilters: $fifthLocalFilters
      schema: $schema
    ) {
      ...AggregateDetailsNoSeriesLimitFragment
    }
    cross9: solitarySingleSegmentation(
      primary: $primaryVar
      filters: $filters
      context: $context
      localFilters: $sixthLocalFilters
      schema: $schema
    ) {
      ...AggregateDetailsNoSeriesLimitFragment
    }
    cross10: solitarySingleSegmentation(
      primary: $primaryVar
      filters: $filters
      context: $context
      localFilters: $seventhLocalFilters
      schema: $schema
    ) {
      ...AggregateDetailsNoSeriesLimitFragment
    }
    cross11: solitarySingleSegmentation(
      primary: $primaryVar
      filters: $filters
      context: $context
      localFilters: $eighthLocalFilters
      schema: $schema
    ) {
      ...AggregateDetailsNoSeriesLimitFragment
    }
    cross12: solitarySingleSegmentation(
      primary: $primaryVar
      filters: $filters
      context: $context
      localFilters: $ninthLocalFilters
      schema: $schema
    ) {
      ...AggregateDetailsNoSeriesLimitFragment
    }
  }
`

export const COMBINED_OS_FUNNEL_QUERY = gql`
  ${AGGREGATE_DETAILS}
  ${AGGREGATE_DETAILS_NO_DATA_LIMIT}
  query CombinedFunnel(
    $primaryVar: MultiVariable!
    $secondPrimaryVar: SingleVariable!
    $secondaryVar: SingleVariable!
    $filters: [Filter!]
    $localFilters: [Filter!]
    $context: [CellInput]!
    $chartType: String
    $limitSeries: Int
    $limitDataPoints: Int
  ) {
    cross: solitaryMulti(
      primary: $primaryVar
      filters: $filters
      context: $context
      localFilters: $localFilters
    ) {
      ...AggregateDetailsFragment
    }
    cross2: solitarySingle(
      primary: $secondPrimaryVar
      filters: $filters
      context: $context
      localFilters: $localFilters
    ) {
      ...AggregateDetailsNoLimitFragment
    }
    cross3: crossSingle(
      primary: $secondaryVar
      secondary: $secondPrimaryVar
      filters: $filters
      context: $context
      localFilters: $localFilters
      chartType: $chartType
    ) {
      ...AggregateDetailsFragment
    }
  }
`

export const MULTI_SOLITARY_SERIES_QUERY = gql`
  ${AGGREGATE_DETAILS}
  query MultiSolitarySeries(
    $primaryVar: SingleVariable!
    $filters: [Filter!]
    $firstLocalFilters: [Filter!]
    $secondLocalFilters: [Filter!]
    $limitSeries: Int
    $limitDataPoints: Int
    $context: [CellInput]!
    $chartType: String
    $showDataPoints: [Int]
  ) {
    cross: solitarySingle(
      primary: $primaryVar
      filters: $filters
      localFilters: $firstLocalFilters
      context: $context
      showDataPoints: $showDataPoints
    ) {
      ...AggregateDetailsFragment
    }
    cross2: solitarySingle(
      primary: $primaryVar
      filters: $filters
      localFilters: $secondLocalFilters
      context: $context
      showDataPoints: $showDataPoints
    ) {
      ...AggregateDetailsFragment
    }
  }
`
export const MULTI_SOLITARY_MULTI_SERIES_QUERY = gql`
  ${AGGREGATE_DETAILS_NO_SERIES_LIMIT}
  ${AGGREGATE_DETAILS_NO_DATA_LIMIT}

  query SolitaryMulti(
    $primaryVar: MultiVariable!
    $filters: [Filter!]
    $limitDataPoints: Int
    $firstLocalFilters: [Filter!]
    $secondLocalFilters: [Filter!]
    $context: [CellInput]!
    $pageNumber: Int
    $itemsPerPage: Int
    $totalItems: Int
    $removeDataPoints: [Int]
  ) {
    cross: solitaryMulti(
      primary: $primaryVar
      filters: $filters
      context: $context
      localFilters: $firstLocalFilters
      pageNumber: $pageNumber
      itemsPerPage: $itemsPerPage
      totalItems: $totalItems
      removeDataPoints: $removeDataPoints
    ) {
      ...AggregateDetailsNoSeriesLimitFragment
    }
    cross2: solitaryMulti(
      primary: $primaryVar
      filters: $filters
      context: $context
      localFilters: $secondLocalFilters
      pageNumber: $pageNumber
      itemsPerPage: $itemsPerPage
      totalItems: $totalItems
      removeDataPoints: $removeDataPoints
    ) {
      ...AggregateDetailsNoLimitFragment
    }
  }
`
export const MULTI_SOLITARY_MULTI_SERIES_NO_LIMIT_QUERY = gql`
  ${AGGREGATE_DETAILS_NO_SERIES_LIMIT}
  ${AGGREGATE_DETAILS_NO_DATA_LIMIT}

  query SolitaryMulti(
    $primaryVar: MultiVariable!
    $filters: [Filter!]
    $limitDataPoints: Int
    $firstLocalFilters: [Filter!]
    $secondLocalFilters: [Filter!]
    $context: [CellInput]!
    $pageNumber: Int
    $itemsPerPage: Int
    $totalItems: Int
    $removeDataPoints: [Int]
  ) {
    cross: solitaryMulti(
      primary: $primaryVar
      filters: $filters
      context: $context
      localFilters: $secondLocalFilters
      pageNumber: $pageNumber
      itemsPerPage: $itemsPerPage
      totalItems: $totalItems
      removeDataPoints: $removeDataPoints
    ) {
      ...AggregateDetailsNoSeriesLimitFragment
    }
    cross2: solitaryMulti(
      primary: $primaryVar
      filters: $filters
      context: $context
      localFilters: $firstLocalFilters
      pageNumber: $pageNumber
      itemsPerPage: $itemsPerPage
      totalItems: $totalItems
      removeDataPoints: $removeDataPoints
    ) {
      ...AggregateDetailsNoLimitFragment
    }
    cross3: solitaryMulti(
      primary: $primaryVar
      filters: $filters
      context: $context
      localFilters: $secondLocalFilters
      pageNumber: $pageNumber
      itemsPerPage: $itemsPerPage
      totalItems: $totalItems
      removeDataPoints: $removeDataPoints
    ) {
      ...AggregateDetailsNoLimitFragment
    }
  }
`

export const MULTI_SOLITARY_SERIES_NO_LIMIT_QUERY = gql`
  ${AGGREGATE_DETAILS}
  ${AGGREGATE_DETAILS_NO_DATA_LIMIT}
  query MultiSolitarySeries(
    $primaryVar: SingleVariable!
    $filters: [Filter!]
    $firstLocalFilters: [Filter!]
    $secondLocalFilters: [Filter!]
    $limitSeries: Int
    $limitDataPoints: Int
    $pageNumber: Int
    $itemsPerPage: Int
    $totalItems: Int
    $context: [CellInput]!
    $chartType: String
    $removeDataPoints: [Int]
  ) {
    cross: solitarySingle(
      primary: $primaryVar
      filters: $filters
      localFilters: $firstLocalFilters
      context: $context
      pageNumber: $pageNumber
      itemsPerPage: $itemsPerPage
      totalItems: $totalItems
      removeDataPoints: $removeDataPoints
    ) {
      ...AggregateDetailsFragment
    }
    cross2: solitarySingle(
      primary: $primaryVar
      filters: $filters
      localFilters: $secondLocalFilters
      context: $context
      pageNumber: $pageNumber
      itemsPerPage: $itemsPerPage
      totalItems: $totalItems
      removeDataPoints: $removeDataPoints
    ) {
      ...AggregateDetailsNoLimitFragment
    }
  }
`
export const MULTI_CONVERSION_QUERY = gql`
  ${AGGREGATE_DETAILS}
  query MultiConversionSeries(
    $primaryVar: SingleVariable!
    $secondaryVar: MultiVariable!
    $secondPrimaryVar: MultiVariable!
    $filters: [Filter!]
    $localFilters: [Filter!]
    $limitSeries: Int
    $chartType: String
    $limitDataPoints: Int
    $context: [CellInput]!
    $removeDataPoints: [Int]
    $showDataPoints: [Int]
  ) {
    cross: crossSingleAndMulti(
      primary: $primaryVar
      secondary: $secondaryVar
      filters: $filters
      context: $context
      localFilters: $localFilters
      removeDataPoints: $removeDataPoints
      showDataPoints: $showDataPoints
    ) {
      ...AggregateDetailsFragment
    }
    cross2: crossSingleAndMulti(
      primary: $primaryVar
      secondary: $secondPrimaryVar
      filters: $filters
      context: $context
      localFilters: $localFilters
      removeDataPoints: $removeDataPoints
      showDataPoints: $showDataPoints
    ) {
      ...AggregateDetailsFragment
    }
  }
`

export const CROSS_AVERAGE_SOLITARY_SERIES_QUERY = gql`
  ${AGGREGATE_DETAILS_AVERAGE}
  ${AGGREGATE_DETAILS}
  query CrossAverageSolitarySeries(
    $primaryVar: SingleVariable!
    $secondaryVar: SingleVariable!
    $filters: [Filter!]
    $firstLocalFilters: [Filter!]
    $limitSeries: Int
    $chartType: String
    $limitDataPoints: Int
    $context: [CellInput]!
  ) {
    cross: crossSingleNumericAvg(
      primary: $primaryVar
      secondary: $secondaryVar
      filters: $filters
      localFilters: []
      context: $context
    ) {
      ...AggregateDetailsAverageFragment
    }
    cross2: solitarySingle(
      primary: $primaryVar
      filters: $filters
      localFilters: $firstLocalFilters
      context: $context
    ) {
      ...AggregateDetailsFragment
    }
  }
`

export const SOLITARY_CONVERSION_RATE_QUERY = gql`
  ${AGGREGATE_DETAILS_NO_SERIES_LIMIT_NO_SUMMARY}
  query solitaryConversionRate(
    $primaryVar: MultiVariable!
    $secondaryVar: MultiOrSingleVariable!
    $filters: [Filter]
    $localFilters: [Filter] = []
    $context: [CellInput]
    $totalVariableSelectionOverride: MultiVariable
    $limitDataPoints: Int
    $pageNumber: Int
    $itemsPerPage: Int
    $totalItems: Int
  ) {
    cross: solitaryConversionRate(
      totalVariable: $primaryVar
      conversionVariable: $secondaryVar
      filters: $filters
      context: $context
      localFilters: $localFilters
      totalVariableSelectionOverride: $totalVariableSelectionOverride
      pageNumber: $pageNumber
      itemsPerPage: $itemsPerPage
      totalItems: $totalItems
    ) {
      ...AggregateDetailsFragmentNoLimitNoSummary
    }
  }
`

export const MULTI_SOLITARY_CONVERSION_RATE_QUERY = gql`
  ${AGGREGATE_DETAILS_NO_SERIES_LIMIT_NO_SUMMARY}
  query solitaryConversionRate(
    $firstPrimaryVar: MultiVariable!
    $secondPrimaryVar: MultiOrSingleVariable!
    $primaryVar: MultiVariable!
    $secondaryVar: MultiOrSingleVariable!
    $filters: [Filter]
    $localFilters: [Filter] = []
    $context: [CellInput]
    $totalVariableSelectionOverride: MultiVariable
    $limitDataPoints: Int
    $pageNumber: Int
    $itemsPerPage: Int
    $totalItems: Int
    $showDataPoints: [Int]
  ) {
    cross: solitaryConversionRate(
      totalVariable: $primaryVar
      conversionVariable: $secondaryVar
      filters: $filters
      context: $context
      localFilters: $localFilters
      totalVariableSelectionOverride: $totalVariableSelectionOverride
      pageNumber: $pageNumber
      itemsPerPage: $itemsPerPage
      totalItems: $totalItems
      showDataPoints: $showDataPoints
    ) {
      ...AggregateDetailsFragmentNoLimitNoSummary
    }
    cross2: solitaryConversionRate(
      totalVariable: $firstPrimaryVar
      conversionVariable: $secondPrimaryVar
      filters: $filters
      context: $context
      localFilters: $localFilters
      totalVariableSelectionOverride: $totalVariableSelectionOverride
      pageNumber: $pageNumber
      itemsPerPage: $itemsPerPage
      totalItems: $totalItems
      showDataPoints: $showDataPoints
    ) {
      ...AggregateDetailsFragmentNoLimitNoSummary
    }
  }
`
export const MULTI_FILTER_SOLITARY_CONVERSION_RATE_QUERY = gql`
  ${AGGREGATE_DETAILS_NO_SERIES_LIMIT_NO_SUMMARY}
  query solitaryConversionRate(
    $firstPrimaryVar: MultiVariable!
    $secondPrimaryVar: MultiOrSingleVariable!
    $primaryVar: MultiVariable!
    $secondaryVar: MultiOrSingleVariable!
    $filters: [Filter]
    $convertedFilter1: [Filter] = []
    $convertedFilter2: [Filter] = []
    $convertedFilter3: [Filter] = []
    $context: [CellInput]
    $totalVariableSelectionOverride: MultiVariable
    $limitDataPoints: Int
    $pageNumber: Int
    $itemsPerPage: Int
    $totalItems: Int
    $showDataPoints: [Int]
  ) {
    cross: solitaryConversionRate(
      totalVariable: $primaryVar
      conversionVariable: $secondaryVar
      filters: $filters
      context: $context
      localFilters: $convertedFilter1
      totalVariableSelectionOverride: $totalVariableSelectionOverride
      pageNumber: $pageNumber
      itemsPerPage: $itemsPerPage
      totalItems: $totalItems
      showDataPoints: $showDataPoints
    ) {
      ...AggregateDetailsFragmentNoLimitNoSummary
    }
    cross2: solitaryConversionRate(
      totalVariable: $primaryVar
      conversionVariable: $secondaryVar
      filters: $filters
      context: $context
      localFilters: $convertedFilter2
      totalVariableSelectionOverride: $totalVariableSelectionOverride
      pageNumber: $pageNumber
      itemsPerPage: $itemsPerPage
      totalItems: $totalItems
      showDataPoints: $showDataPoints
    ) {
      ...AggregateDetailsFragmentNoLimitNoSummary
    }
    cross3: solitaryConversionRate(
      totalVariable: $primaryVar
      conversionVariable: $secondaryVar
      filters: $filters
      context: $context
      localFilters: $convertedFilter3
      totalVariableSelectionOverride: $totalVariableSelectionOverride
      pageNumber: $pageNumber
      itemsPerPage: $itemsPerPage
      totalItems: $totalItems
      showDataPoints: $showDataPoints
    ) {
      ...AggregateDetailsFragmentNoLimitNoSummary
    }
    cross4: solitaryConversionRate(
      totalVariable: $firstPrimaryVar
      conversionVariable: $secondPrimaryVar
      filters: $filters
      context: $context
      totalVariableSelectionOverride: $totalVariableSelectionOverride
      pageNumber: $pageNumber
      itemsPerPage: $itemsPerPage
      totalItems: $totalItems
      showDataPoints: $showDataPoints
    ) {
      ...AggregateDetailsFragmentNoLimitNoSummary
    }
  }
`
export const MULTI_FILTER_ROW_PILL_QUERY = gql`
  ${AGGREGATE_DETAILS}
  query CrossSingleQuery(
    $primaryVar: SingleVariable!
    $secondaryVar: MultiVariable!
    $filters: [Filter!]
    $limitSeries: Int
    $limitDataPoints: Int
    $chartType: String
    $context: [CellInput]!
    $showDataPoints: [Int]
    $secondShowDataPoints: [Int]
    $thirdShowDataPoints: [Int]
    $pageNumber: Int
    $itemsPerPage: Int
    $totalItems: Int
  ) {
    cross: crossSingleAndMulti(
      primary: $primaryVar
      secondary: $secondaryVar
      filters: $filters
      context: $context
      showDataPoints: $showDataPoints
      pageNumber: $pageNumber
      itemsPerPage: $itemsPerPage
      totalItems: $totalItems
    ) {
      ...AggregateDetailsFragment
    }
    cross2: crossSingleAndMulti(
      primary: $primaryVar
      secondary: $secondaryVar
      filters: $filters
      context: $context
      showDataPoints: $secondShowDataPoints
      pageNumber: $pageNumber
      itemsPerPage: $itemsPerPage
      totalItems: $totalItems
    ) {
      ...AggregateDetailsFragment
    }
    cross3: crossSingleAndMulti(
      primary: $primaryVar
      secondary: $secondaryVar
      filters: $filters
      context: $context
      showDataPoints: $thirdShowDataPoints
      pageNumber: $pageNumber
      itemsPerPage: $itemsPerPage
      totalItems: $totalItems
    ) {
      ...AggregateDetailsFragment
    }
  }
`

export const MULTI_SOLITARY_CONVERSION_RATE_TRENDED_QUERY = gql`
  ${AGGREGATE_DETAILS}
  query solitaryConversionRateTrended(
    $primaryVar: SingleVariable!
    $firstPrimaryVar: MultiVariable!
    $secondaryVar: MultiOrSingleVariable!
    $secondPrimaryVar: MultiOrSingleVariable
    $filters: [Filter]
    $localFilters: [Filter] = []
    $context: [CellInput]
    $limitDataPoints: Int
    $limitSeries: Int
    $pageNumber: Int
    $itemsPerPage: Int
    $totalItems: Int
    $showDataPoints: [Int]
    $chartType: String
  ) {
    cross: solitaryConversionRateTrended(
      primary: $primaryVar
      secondary: $firstPrimaryVar
      tertiary: $secondaryVar
      filters: $filters
      context: $context
      localFilters: $localFilters
      pageNumber: $pageNumber
      itemsPerPage: $itemsPerPage
      totalItems: $totalItems
      showDataPoints: $showDataPoints
    ) {
      ...AggregateDetailsFragment
    }
    cross2: solitaryConversionRateTrended(
      primary: $primaryVar
      secondary: $firstPrimaryVar
      tertiary: $secondPrimaryVar
      filters: $filters
      context: $context
      localFilters: $localFilters
      pageNumber: $pageNumber
      itemsPerPage: $itemsPerPage
      totalItems: $totalItems
      showDataPoints: $showDataPoints
    ) {
      ...AggregateDetailsFragment
    }
  }
`

export const MULTI_FILLTER_SOLITARY_CONVERSION_RATE_TRENDED_QUERY = gql`
  ${AGGREGATE_DETAILS}
  query solitaryConversionRateTrended(
    $primaryVar: SingleVariable!
    $firstPrimaryVar: MultiVariable!
    $secondaryVar: MultiOrSingleVariable!
    $secondPrimaryVar: MultiOrSingleVariable
    $filters: [Filter]
    $convertedFilter1: [Filter] = []
    $convertedFilter2: [Filter] = []
    $convertedFilter3: [Filter] = []
    $context: [CellInput]
    $limitDataPoints: Int
    $limitSeries: Int
    $pageNumber: Int
    $itemsPerPage: Int
    $totalItems: Int
    $showDataPoints: [Int]
    $chartType: String
  ) {
    cross: solitaryConversionRateTrended(
      primary: $primaryVar
      secondary: $firstPrimaryVar
      tertiary: $secondaryVar
      filters: $filters
      context: $context
      localFilters: $convertedFilter1
      pageNumber: $pageNumber
      itemsPerPage: $itemsPerPage
      totalItems: $totalItems
      showDataPoints: $showDataPoints
    ) {
      ...AggregateDetailsFragment
    }
    cross2: solitaryConversionRateTrended(
      primary: $primaryVar
      secondary: $firstPrimaryVar
      tertiary: $secondaryVar
      filters: $filters
      context: $context
      localFilters: $convertedFilter2
      pageNumber: $pageNumber
      itemsPerPage: $itemsPerPage
      totalItems: $totalItems
      showDataPoints: $showDataPoints
    ) {
      ...AggregateDetailsFragment
    }
    cross3: solitaryConversionRateTrended(
      primary: $primaryVar
      secondary: $firstPrimaryVar
      tertiary: $secondaryVar
      filters: $filters
      context: $context
      localFilters: $convertedFilter3
      pageNumber: $pageNumber
      itemsPerPage: $itemsPerPage
      totalItems: $totalItems
      showDataPoints: $showDataPoints
    ) {
      ...AggregateDetailsFragment
    }
    cross4: solitaryConversionRateTrended(
      primary: $primaryVar
      secondary: $firstPrimaryVar
      tertiary: $secondPrimaryVar
      filters: $filters
      context: $context
      pageNumber: $pageNumber
      itemsPerPage: $itemsPerPage
      totalItems: $totalItems
      showDataPoints: $showDataPoints
    ) {
      ...AggregateDetailsFragment
    }
  }
`

export const MULTI_CROSS_SINGLE_QUERY = gql`
  ${AGGREGATE_DETAILS}
  query CrossSingleQuery(
    $primaryVar: SingleVariable!
    $secondaryVar: SingleVariable!
    $tertiaryVar: SingleVariable
    $filters: [Filter!]
    $firstLocalFilters: [Filter!]
    $secondLocalFilters: [Filter!]
    $limitSeries: Int
    $limitDataPoints: Int
    $chartType: String
    $context: [CellInput]!
    $schema: String
    $removeDataPoints: [Int]
    $showDataPoints: [Int]
    $pageNumber: Int
    $itemsPerPage: Int
    $totalItems: Int
  ) {
    cross: crossSingle(
      primary: $primaryVar
      secondary: $secondaryVar
      filters: $filters
      context: $context
      localFilters: $firstLocalFilters
      schema: $schema
      removeDataPoints: $removeDataPoints
      showDataPoints: $showDataPoints
      pageNumber: $pageNumber
      itemsPerPage: $itemsPerPage
      totalItems: $totalItems
      tertiary: $tertiaryVar
    ) {
      ...AggregateDetailsFragment
    }
    cross2: crossSingle(
      primary: $primaryVar
      secondary: $secondaryVar
      filters: $filters
      context: $context
      localFilters: $secondLocalFilters
      schema: $schema
      removeDataPoints: $removeDataPoints
      showDataPoints: $showDataPoints
      pageNumber: $pageNumber
      itemsPerPage: $itemsPerPage
      totalItems: $totalItems
      tertiary: $tertiaryVar
    ) {
      ...AggregateDetailsFragment
    }
  }
`
export const MULTI_CROSS_NPS_QUERY = gql`
  ${AGGREGATE_DETAILS}
  query CrossSingleQuery(
    $primaryVar: SingleVariable!
    $secondaryVar: SingleVariable!
    $secondPrimaryVar: SingleVariable!
    $tertiaryVar: SingleVariable
    $filters: [Filter!]
    $firstLocalFilters: [Filter!]
    $secondLocalFilters: [Filter!]
    $thirdLocalFilters: [Filter!]
    $fourthLocalFilters: [Filter!]
    $limitSeries: Int
    $limitDataPoints: Int
    $chartType: String
    $context: [CellInput]!
    $schema: String
    $removeDataPoints: [Int]
    $showDataPoints: [Int]
    $secondShowDataPoints: [Int]
    $pageNumber: Int
    $itemsPerPage: Int
    $totalItems: Int
  ) {
    cross: crossSingle(
      primary: $primaryVar
      secondary: $secondaryVar
      filters: $filters
      context: $context
      localFilters: $firstLocalFilters
      schema: $schema
      removeDataPoints: $removeDataPoints
      showDataPoints: $showDataPoints
      pageNumber: $pageNumber
      itemsPerPage: $itemsPerPage
      totalItems: $totalItems
      tertiary: $tertiaryVar
    ) {
      ...AggregateDetailsFragment
    }
    cross2: crossSingle(
      primary: $primaryVar
      secondary: $secondaryVar
      filters: $filters
      context: $context
      localFilters: $secondLocalFilters
      schema: $schema
      removeDataPoints: $removeDataPoints
      showDataPoints: $showDataPoints
      pageNumber: $pageNumber
      itemsPerPage: $itemsPerPage
      totalItems: $totalItems
      tertiary: $tertiaryVar
    ) {
      ...AggregateDetailsFragment
    }
    cross3: crossSingle(
      primary: $primaryVar
      secondary: $secondaryVar
      filters: $filters
      context: $context
      localFilters: $thirdLocalFilters
      schema: $schema
      removeDataPoints: $removeDataPoints
      showDataPoints: $showDataPoints
      pageNumber: $pageNumber
      itemsPerPage: $itemsPerPage
      totalItems: $totalItems
      tertiary: $tertiaryVar
    ) {
      ...AggregateDetailsFragment
    }
    cross4: crossSingle(
      primary: $primaryVar
      secondary: $secondPrimaryVar
      filters: $filters
      context: $context
      localFilters: $fourthLocalFilters
      schema: $schema
      removeDataPoints: $removeDataPoints
      showDataPoints: $secondShowDataPoints
      pageNumber: $pageNumber
      itemsPerPage: $itemsPerPage
      totalItems: $totalItems
      tertiary: $tertiaryVar
    ) {
      ...AggregateDetailsFragment
    }
  }
`
export const GET_SUMMARY_VALUES = gql`
  query summaryValues(
    $primaryVar: SingleVariable!
    $filters: [Filter]
    $localFilters: [Filter] = []
    $context: [CellInput]
    $schema: String
  ) {
    cross: summaryValues(
      primary: $primaryVar
      filters: $filters
      context: $context
      localFilters: $localFilters
      schema: $schema
    ) {
      totalCountUnweighted
    }
  }
`

export const CROSS_MULTI_SINGLE_QUERY = gql`
  ${AGGREGATE_DETAILS}

  query CrossMultiSingleQuery(
    $primaryVar: MultiVariable!
    $secondaryVar: SingleVariable!
    $filters: [Filter!]
    $localFilters: [Filter!] = []
    $limitSeries: Int
    $chartType: String
    $limitDataPoints: Int
    $context: [CellInput]!
    $pageNumber: Int
    $itemsPerPage: Int
    $totalItems: Int
  ) {
    cross: crossMultiSingle(
      primary: $primaryVar
      secondary: $secondaryVar
      filters: $filters
      context: $context
      localFilters: $localFilters
      pageNumber: $pageNumber
      itemsPerPage: $itemsPerPage
      totalItems: $totalItems
    ) {
      ...AggregateDetailsFragment
    }
  }
`

export const SOLITARY_MULTI_DISTRIBUTION_QUERY = gql`
  ${AGGREGATE_DETAILS_NO_SUMMARY}

  query SolitaryMultiDistributionQuery(
    $primaryVars: [MultiVariable!]
    $primaryValues: [String!]
    $filters: [Filter!]
    $localFilters: [Filter!]
    $context: [CellInput]!
    $transposeAxis: Boolean
    $limitSeries: Int
    $limitDataPoints: Int
    $removeDataPoints: [Int]
    $pageNumber: Int
    $itemsPerPage: Int
    $totalItems: Int
  ) {
    cross: solitaryMultiDistribution(
      primary: $primaryVars
      primaryValues: $primaryValues
      filters: $filters
      context: $context
      localFilters: $localFilters
      transposeAxis: $transposeAxis
      removeDataPoints: $removeDataPoints
      pageNumber: $pageNumber
      itemsPerPage: $itemsPerPage
      totalItems: $totalItems
    ) {
      ...AggregateDetailsFragmentNoSummary
    }
  }
`
export const BRANDS_OVERVIEW_QUERY = gql`
  ${AGGREGATE_DETAILS_NO_SERIES_LIMIT_NO_SUMMARY}
  ${AGGREGATE_DETAILS}
  ${AGGREGATE_DETAILS_NO_SUMMARY}

  query BrandsOverview(
    $conversionTotalVar: MultiVariable!
    $conversionVar: MultiOrSingleVariable!
    $singlePrimaryVar: SingleVariable!
    $singleSecondaryVar: SingleVariable!
    $single2PrimaryVar: SingleVariable!
    $single2SecondaryVar: SingleVariable!
    $distributionPrimaryVars: [MultiVariable!]
    $distributionPrimaryValues: [String!]
    $filters: [Filter!]
    $localFilters: [Filter!] = []
    $singleLocalFilters: [Filter!] = []
    $single2LocalFilters: [Filter!] = []
    $distributionLocalFilters: [Filter!]
    $context: [CellInput]!
    $totalVariableSelectionOverride: MultiVariable
    $transposeAxis: Boolean
    $limitSeries: Int
    $limitDataPoints: Int
    $removeDataPoints: [Int]
    $pageNumber: Int
    $itemsPerPage: Int
    $totalItems: Int
    $chartType: String
  ) {
    cross: solitaryConversionRate(
      totalVariable: $conversionTotalVar
      conversionVariable: $conversionVar
      filters: $filters
      context: $context
      localFilters: $localFilters
      totalVariableSelectionOverride: $totalVariableSelectionOverride
      pageNumber: $pageNumber
      itemsPerPage: $itemsPerPage
      totalItems: $totalItems
    ) {
      ...AggregateDetailsFragmentNoLimitNoSummary
    }
    cross2: crossSingle(
      primary: $singlePrimaryVar
      secondary: $singleSecondaryVar
      filters: $filters
      context: $context
      localFilters: $singleLocalFilters
      removeDataPoints: $removeDataPoints
      pageNumber: $pageNumber
      itemsPerPage: $itemsPerPage
      totalItems: $totalItems
      chartType: $chartType
    ) {
      ...AggregateDetailsFragment
    }
    cross3: crossSingle(
      primary: $single2PrimaryVar
      secondary: $single2SecondaryVar
      filters: $filters
      context: $context
      localFilters: $single2LocalFilters
      removeDataPoints: $removeDataPoints
      pageNumber: $pageNumber
      itemsPerPage: $itemsPerPage
      totalItems: $totalItems
      chartType: $chartType
    ) {
      ...AggregateDetailsFragment
    }
    cross4: solitaryMultiDistribution(
      primary: $distributionPrimaryVars
      primaryValues: $distributionPrimaryValues
      filters: $filters
      context: $context
      localFilters: $distributionLocalFilters
      transposeAxis: $transposeAxis
      removeDataPoints: $removeDataPoints
      pageNumber: $pageNumber
      itemsPerPage: $itemsPerPage
      totalItems: $totalItems
    ) {
      ...AggregateDetailsFragmentNoSummary
    }
  }
`
export const RETAILERS_OVERVIEW_QUERY = gql`
  ${AGGREGATE_DETAILS}
  ${AGGREGATE_DETAILS_NO_SERIES_LIMIT}
  ${SUMMARY_SERIES_DETAILS}

  query RetailersOverview(
    $crossPrimaryVar: SingleVariable!
    $crossSecondaryVar: SingleVariable!
    $crossTertiaryVar: SingleVariable
    $solitaryPrimaryVar: SingleVariable!
    $summaryPrimaryVar: SingleVariable!
    $summarySecondaryVar: MultiVariable!
    $filters: [Filter!]
    $crossLocalFilters: [Filter!] = []
    $solitaryLocalFilters: [Filter!] = []
    $summaryLocalFilters: [Filter!] = []
    $limitSeries: Int
    $limitDataPoints: Int
    $chartType: String
    $context: [CellInput]!
    $schema: String
    $removeDataPoints: [Int]
    $showDataPoints: [Int]
    $pageNumber: Int
    $itemsPerPage: Int
    $totalItems: Int
    $reviewAverage: Boolean
  ) {
    cross: crossSingle(
      primary: $crossPrimaryVar
      secondary: $crossSecondaryVar
      tertiary: $crossTertiaryVar
      filters: $filters
      context: $context
      localFilters: $crossLocalFilters
      schema: $schema
      removeDataPoints: $removeDataPoints
      showDataPoints: $showDataPoints
      pageNumber: $pageNumber
      itemsPerPage: $itemsPerPage
      totalItems: $totalItems
      reviewAverage: $reviewAverage
      chartType: $chartType
    ) {
      ...AggregateDetailsFragment
    }
    cross2: solitarySingle(
      primary: $solitaryPrimaryVar
      filters: $filters
      context: $context
      localFilters: $solitaryLocalFilters
      schema: $schema
      pageNumber: $pageNumber
      itemsPerPage: $itemsPerPage
      totalItems: $totalItems
      removeDataPoints: $removeDataPoints
    ) {
      ...AggregateDetailsNoSeriesLimitFragment
    }
    cross3: crossSingleAndMulti(
      primary: $summaryPrimaryVar
      secondary: $summarySecondaryVar
      filters: $filters
      context: $context
      localFilters: $summaryLocalFilters
    ) {
      ...SummarySeriesDetailsFragment
    }
  }
`
export const MULTI_SOLITARY_MULTI_DISTRIBUTION_QUERY = gql`
  ${AGGREGATE_DETAILS_NO_SUMMARY}
  ${AGGREGATE_DETAILS_NO_SERIES_LIMIT_NO_SUMMARY}

  query SolitaryMultiDistributionQuery(
    $primaryVars: [MultiVariable!]
    $primaryValues: [String!]
    $filters: [Filter!]
    $firstLocalFilters: [Filter!]
    $secondLocalFilters: [Filter!]
    $context: [CellInput]!
    $transposeAxis: Boolean
    $limitSeries: Int
    $limitDataPoints: Int
    $removeDataPoints: [Int]
    $pageNumber: Int
    $itemsPerPage: Int
    $totalItems: Int
    $sortedSeries: Boolean
    $selectValue: String
  ) {
    cross: solitaryMultiDistribution(
      primary: $primaryVars
      primaryValues: $primaryValues
      filters: $filters
      context: $context
      localFilters: $firstLocalFilters
      transposeAxis: $transposeAxis
      removeDataPoints: $removeDataPoints
      pageNumber: $pageNumber
      itemsPerPage: $itemsPerPage
      totalItems: $totalItems
      sortedSeries: $sortedSeries
      selectValue: $selectValue
    ) {
      ...AggregateDetailsFragmentNoSummary
    }
    cross2: solitaryMultiDistribution(
      primary: $primaryVars
      primaryValues: $primaryValues
      filters: $filters
      context: $context
      localFilters: $secondLocalFilters
      transposeAxis: $transposeAxis
      removeDataPoints: $removeDataPoints
      pageNumber: $pageNumber
      itemsPerPage: $itemsPerPage
      totalItems: $totalItems
      sortedSeries: $sortedSeries
      selectValue: $selectValue
    ) {
      ...AggregateDetailsFragmentNoLimitNoSummary
    }
  }
`
export const SOLITARY_MULTI_FEATURE_DISTRIBUTION_QUERY = gql`
  ${AGGREGATE_DETAILS_NO_SUMMARY}

  query solitaryMultiFeatureDistributionQuery(
    $primaryVars: [MultiVariable!]
    $primaryValues: [String!]
    $filters: [Filter!]
    $localFilters: [Filter!]
    $context: [CellInput]!
    $featureDesign: Boolean
    $limitSeries: Int
    $limitDataPoints: Int
    $removeDataPoints: [Int]
  ) {
    cross: solitaryMultiFeatureDistribution(
      primary: $primaryVars
      primaryValues: $primaryValues
      filters: $filters
      context: $context
      localFilters: $localFilters
      removeDataPoints: $removeDataPoints
      featureDesign: $featureDesign
    ) {
      ...AggregateDetailsFragmentNoSummary
    }
  }
`
export const CROSS_MULTI_OR_SINGLE_TRENDED_QUERY = gql`
  ${AGGREGATE_DETAILS}
  query solitaryConversionRateTrended(
    $primaryVar: SingleVariable!
    $secondaryVar: MultiVariable!
    $tertiaryVar: MultiOrSingleVariable
    $filters: [Filter]
    $localFilters: [Filter] = []
    $context: [CellInput]
    $pageNumber: Int
    $itemsPerPage: Int
    $totalItems: Int
    $showDataPoints: [Int]
    $limitSeries: Int
    $limitDataPoints: Int
    $chartType: String
  ) {
    cross: solitaryConversionRateTrended(
      primary: $primaryVar
      secondary: $secondaryVar
      tertiary: $tertiaryVar
      filters: $filters
      context: $context
      localFilters: $localFilters
      pageNumber: $pageNumber
      itemsPerPage: $itemsPerPage
      totalItems: $totalItems
      showDataPoints: $showDataPoints
    ) {
      ...AggregateDetailsFragment
    }
  }
`
export const MULTI_CROSS_MULTI_OR_SINGLE_TRENDED_QUERY = gql`
  ${AGGREGATE_DETAILS}

  query MultiCrossMultiSingleTrended(
    $primaryVar: SingleVariable!
    $secondaryVar: MultiVariable!
    $tertiaryVar: MultiOrSingleVariable!
    $totalVariable: MultiOrSingleVariable
    $filters: [Filter]
    $localFilters: [Filter] = []
    $context: [CellInput]
    $limitDataPoints: Int
    $pageNumber: Int
    $itemsPerPage: Int
    $totalItems: Int
    $showDataPoints: [Int]
    $limitSeries: Int
    $chartType: String
  ) {
    cross: solitaryConversionRateTrended(
      primary: $primaryVar
      secondary: $secondaryVar
      tertiary: $tertiaryVar
      totalVariable: $totalVariable
      filters: $filters
      context: $context
      localFilters: $localFilters
      pageNumber: $pageNumber
      itemsPerPage: $itemsPerPage
      totalItems: $totalItems
      showDataPoints: $showDataPoints
    ) {
      ...AggregateDetailsFragment
    }
  }
`
export const SHOPPER_OVERVIEW_QUERY = gql`
  ${AGGREGATE_DETAILS}
  ${AGGREGATE_DETAILS_AVERAGE}
  query ShopperOverviewQuery(
    $primaryVar: SingleVariable!
    $multiSecondaryVar: MultiVariable!
    $secondaryVar2: SingleVariable!
    $secondaryVar3: SingleVariable!
    $filters: [Filter!]
    $localFilters: [Filter!]
    $limitSeries: Int
    $limitDataPoints: Int
    $chartType: String
    $context: [CellInput]!
    $schema: String
    $removeDataPoints: [Int]
    $showDataPoints: [Int]
    $pageNumber: Int
    $itemsPerPage: Int
    $totalItems: Int
  ) {
    cross: crossSingleAndMulti(
      primary: $primaryVar
      secondary: $multiSecondaryVar
      filters: $filters
      context: $context
      localFilters: $localFilters
      removeDataPoints: $removeDataPoints
      showDataPoints: $showDataPoints
      pageNumber: $pageNumber
      itemsPerPage: $itemsPerPage
      totalItems: $totalItems
    ) {
      ...AggregateDetailsFragment
    }
    cross2: crossSingle(
      primary: $primaryVar
      secondary: $secondaryVar2
      filters: $filters
      context: $context
      localFilters: $localFilters
      schema: $schema
      removeDataPoints: $removeDataPoints
      showDataPoints: $showDataPoints
      pageNumber: $pageNumber
      itemsPerPage: $itemsPerPage
      totalItems: $totalItems
    ) {
      ...AggregateDetailsFragment
    }
    cross3: crossSingleNumericAvg(
      primary: $primaryVar
      secondary: $secondaryVar3
      filters: $filters
      localFilters: $localFilters
      context: $context
    ) {
      ...AggregateDetailsAverageFragment
    }
  }
`
